import { Maybe, Patient, OrgAccessRef } from '@csp/csp-common-model';
import { UserV1 } from '@csp/dmdp-api-user-dto';
import { UserUtil } from '@csp/csp-common-user';
import { RoleType } from '@csp/dmdp-api-common-dto';

const getActiveOrgAccessRef = (userV1: Partial<UserV1>): Maybe<OrgAccessRef> => {
  // Patients can only belong to 1 site.
  const { firstOrgAccessRef } = UserUtil.getUserOrgs(
    userV1.roleAccessRefs?.filter(roleAccessRef => roleAccessRef.role === RoleType.PATIENT),
  );

  return firstOrgAccessRef;
};

const getEcode = (userV1: UserV1): string => userV1.study?.ecode || 'No patient ID';

const getPatientTimeZoneId = (patient: Patient): string | undefined => patient.clientInfo.lastActivityTimestamp?.zone;

export const PatientUtil = {
  getActiveOrgAccessRef,
  getEcode,
  getPatientTimeZoneId,
};
